import { render } from "./ForgotPasswordDialog.vue?vue&type=template&id=861d7ba6"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__